import {Component, OnInit} from '@angular/core';
import {AmenitiesService} from '../../../services/amenities.service';
import {ApiClientService} from '../../../services/api-client.service';
import {Amenity} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';

declare const moment: any;
declare const toastr: any;

@Component({
    selector: 'amenities-payments',
    templateUrl: './amenities-payments.component.html',
    styleUrls: ['./amenities-payments.component.scss']
})
export class AmenitiesPaymentsComponent implements OnInit {

    data: Amenity = new Amenity();
    amenityFees = [];
    amenityType = '';
    showTimeSelectSpinner = false;
    originalRules = null;
    nextDayEndTimes = [];
    daySelectedNumber = null;
    startHour = '';
    endHour = '';
    paymentMethods = {
        cash: 'Cash',
        cheque: 'Cheque',
        credit_card: 'Credit Card',
        certified_cheque: 'Certified Cheque',
        money_order: 'Money Order',
        bank_draft: 'Bank Draft',
    };
    creditCardNumbersString = '';
    disabledSubmit = false;

    constructor(public api: ApiClientService,
                public amenitiesService: AmenitiesService,
                public authService: AuthenticationService,
    ) {}

    ngOnInit() {
        this.initData();
    }

    initData() {
        this.showTimeSelectSpinner = false;
        if (this.amenitiesService.amenityInAmenityModal) {
            this.data = Object.assign({}, this.amenitiesService.amenityInAmenityModal);
            this.amenityType = '';
            this.showTimeSelectSpinner = true;
            let url = '';
            if(!this.authService.userIsResident)
                url = `/v1/amenity/${this.amenitiesService.amenityInAmenityModal.amenityId}.json?expand=buildingAmenity,fees`;
            else
                url = `/v1/booking/${this.amenitiesService.amenityInAmenityModal.id}.json?expand=amenity,amenity.buildingAmenity,amenity.fees,`;
            this.api.get('domainAmenities', `${url}`).subscribe(
                (res) => {
                    this.showTimeSelectSpinner = false;
                    const amenity = !this.authService.userIsResident ? JSON.parse(res._body) : JSON.parse(res._body).amenity;
                    this.originalRules = amenity.rule;
                    this.amenityType = amenity.timeSequenceType;
                    if (amenity.fees) {
                        amenity.fees.forEach((fee) => {
                            this.amenityFees.push({
                                id: fee.id,
                                active: fee.active,
                                name: fee.name,
                                status: fee.status,
                                amount: fee.amount,
                                required: fee.required,
                                include: fee.required ? true : false,
                                refundable: fee.refundable,
                                pmtAtTime: fee.pmtAtTime,
                                pmtHourly: fee.pmtHourly
                            });
                        });
                        this.data.payments.forEach((payment) => {
                            if (payment.paymentType)
                                this.data.paymentMethod = payment.paymentType;
                            this.amenityFees.forEach((fee) => {
                                if (fee.name == payment.name && fee.status != payment.status)
                                    fee.status = payment.status;
                                if (fee.name == payment.name && fee.include != payment.chosen)
                                    fee.include = payment.chosen;
                                if(fee.id == payment.fee) {
                                    fee.paymentId = payment.id;
                                    fee.waived = payment.waived;
                                }
                            });
                        });


                        this.daySelectedNumber = new Date(this.data.dateFrom).getDay();
                        const startDay = this.getTimeInZeroTimezone(this.data.dateFrom).getDate();
                        const startMonth = this.getTimeInZeroTimezone(this.data.dateFrom).getMonth() + 1;
                        const startYear = this.getTimeInZeroTimezone(this.data.dateFrom).getFullYear();
                        this.data.day = (startDay > 9 ? startDay : '0' + startDay) + '.' +
                            (startMonth > 9 ? startMonth : '0' + startMonth) + '.' + startYear;
                        if (this.amenityType == 'daily') {
                            const endDay = this.getTimeInZeroTimezone(this.data.dateTo).getDate();
                            const endMonth = this.getTimeInZeroTimezone(this.data.dateTo).getMonth() + 1;
                            const endYear = this.getTimeInZeroTimezone(this.data.dateTo).getFullYear();
                            this.data.endDay = (endDay > 9 ? endDay : '0' + endDay) + '.' +
                                (endMonth > 9 ? endMonth : '0' + endMonth) + '.' + endYear;

                        }
                        if (this.amenityType == 'hourly' || this.amenityType == 'range') {
                            this.getOvernightEndHours();
                            const startTime = this.getTimeInZeroTimezone(this.data.dateFrom);
                            const endTime = this.getTimeInZeroTimezone(this.data.dateTo);
                            if (this.amenityType == 'hourly') {
                                this.startHour = (
                                        startTime.getHours() <= 12 ?
                                            (startTime.getHours() == 0 ? 12 : (startTime.getHours() < 10 ? '0' + startTime.getHours() : startTime.getHours())) :
                                            ((startTime.getHours() - 12) < 10 ? '0' + (startTime.getHours() - 12) : (startTime.getHours() - 12))
                                    )
                                    + ':' + (startTime.getMinutes() < 10 ? '0' + startTime.getMinutes() : startTime.getMinutes())
                                    + ((startTime.getHours() < 12 || startTime.getHours() == 24) ? ' AM' : ' PM');
                                this.endHour = (
                                        endTime.getHours() <= 12 ?
                                            (endTime.getHours() == 0 ? 12 : (endTime.getHours() < 10 ? '0' + endTime.getHours() : endTime.getHours())) :
                                            ((endTime.getHours() - 12) < 10 ? '0' + (endTime.getHours() - 12) : (endTime.getHours() - 12))
                                    )
                                    + ':' + (endTime.getMinutes() < 10 ? '0' + endTime.getMinutes() : endTime.getMinutes())
                                    + ((endTime.getHours() < 12 || endTime.getHours() == 24) ? ' AM' : ' PM');
                                const endStartDay = this.getTimeInZeroTimezone(this.data.dateTo).getDate();
                                const endStartMonth = this.getTimeInZeroTimezone(this.data.dateTo).getMonth() + 1;
                                const endStartYear = this.getTimeInZeroTimezone(this.data.dateTo).getFullYear();
                                this.data.endDay = (endStartDay > 9 ? endStartDay : '0' + endStartDay) + '.' +
                                    (endStartMonth > 9 ? endStartMonth : '0' + endStartMonth) + '.' + endStartYear;

                            }


                        }
                    }
                    if(amenity.paymentCustomTypeName)
                        this.paymentMethods['custom_type'] = amenity.paymentCustomTypeName;

                    this.setCreditCardNumbersString();
                },
                (error) => this.api.errorHandler(error, 'Failed get Amenity For Editing')
            );
        }
    }

    getStartEndDayDifference(): number {
        return Math.round((new Date(parseInt(this.data.endDay.split('.')[2]), parseInt(this.data.endDay.split('.')[1]) - 1, parseInt(this.data.endDay.split('.')[0])).getTime() -
            new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])).getTime()) / (24 * 3600000));
    }

    getStartEndHourDifference(): number {
        return (+moment.utc(moment(this.data.dateTo).diff(moment(this.data.dateFrom))).format('x')) / (60 * 60 * 1000);
    }

    getTimeInZeroTimezone(date): any {
        return new Date(new Date(date).getTime() + new Date(date).getTimezoneOffset() * 60000);
    }


    getOvernightEndHours(): void {
        this.nextDayEndTimes = [];
        let dayEndsAtMidnight = false;
        let index = -1;
        for (let i = 0; i < this.originalRules.weekDays.length; i++) {
            if (this.originalRules.weekDays[i].dayNumber == this.daySelectedNumber) {
                this.originalRules.weekDays[i].dayHours.filter((hours) => {
                    if (hours.maxHour == '1970-01-02T00:00:00+00:00') {
                        dayEndsAtMidnight = true;
                    }
                });
            }
        }
        if (dayEndsAtMidnight) {
            for (let i = 0; i < this.originalRules.weekDays.length; i++) {
                if (this.originalRules.weekDays[i].dayNumber == (this.daySelectedNumber == 7 ? 1 : this.daySelectedNumber + 1)) {
                    index = i;
                    break;
                }
            }
        }
        if (index != -1) {
            let overnightDayHours = null;
            this.originalRules.weekDays[index].dayHours.forEach((hours) => {
                if (new Date(hours.minHour).getTime() == 0) {
                    overnightDayHours = hours;
                }
            });
            if (overnightDayHours) {
                const timestep = this.originalRules.timeStep;
                const minHour = new Date(overnightDayHours.minHour);
                const maxHour = new Date(overnightDayHours.maxHour);
                const startHour = this.getTimeInZeroTimezone(minHour).getHours();
                const endHour = this.getTimeInZeroTimezone(maxHour).getHours();
                const startMinutes = minHour.getMinutes();
                const endMinutes = maxHour.getMinutes() + 1;
                for (let i = startHour; i < endHour + 1; i++) {
                    for (let j = startMinutes; j < ((i + 1 == endHour + 1) ? endMinutes : 60); j += timestep) {
                        if (j < 60) {
                            const hour = (i <= 12 ? (i == 0 ? 12 : i) : i - 12);
                            const minutes = (j < 10 ? '0' + j : j);
                            const amPm = (i < 12 || i == 24 ? ' AM' : ' PM');
                            this.nextDayEndTimes.push((hour < 10 ? '0' + hour : hour) + ':' + minutes + amPm);
                        }
                    }
                }
            } else {
                this.data.endDay = this.data.day;
            }
        } else {
            this.data.endDay = this.data.day;
        }
    }

    getTotalPaymentValue(): any {
        let returnValue = 0;
        this.amenityFees.forEach((fee) => {
            if (fee.include && fee.active && !fee.refundable && !fee.waived) {
                if (!fee.pmtAtTime && !fee.pmtHourly) {
                    returnValue += parseFloat(fee.amount.replace(',', '.'));
                } else if(fee.pmtAtTime) {
                    returnValue += parseFloat(fee.amount.replace(',', '.')) * this.getStartEndDayDifference();
                } else if(fee.pmtHourly) {
                    returnValue += parseFloat(fee.amount.replace(',', '.')) * this.getStartEndHourDifference();
                }
            }
        });
        return parseFloat(returnValue.toString()).toFixed(2);
    }

    getReservationProcessingFeeValue(): any {
        const returnValue = this.getTotalPaymentValue() != '0.00' ? ((parseFloat(this.getTotalPaymentValue()) * 1.01 + 0.3) / 0.971) - parseFloat(this.getTotalPaymentValue()) : 0;
        return parseFloat(returnValue.toString()).toFixed(2);
    }

    getTotalCharged(): any {
        return parseFloat((parseFloat(this.getTotalPaymentValue()) + (this.data.paymentMethod == 'credit_card' ? parseFloat(this.getReservationProcessingFeeValue()) : 0)).toString()).toFixed(2);
    }

    getTotalRefundableValue(): any {
        let returnValue = 0;
        this.amenityFees.forEach((fee) => {
            if (fee.include && fee.active && fee.refundable && !fee.waived) {
                returnValue += parseFloat(fee.amount.replace(',', '.'));
            }
        });
        return parseFloat(returnValue.toString()).toFixed(2);
    }

    setCreditCardNumbersString(): void {
        if(this.data.paymentMethod == 'credit_card') {
            this.data.stripePayments.forEach((payment, index) => {
                if(this.creditCardNumbersString.indexOf(payment.cardNumber) == -1) {
                    this.creditCardNumbersString += index != 0 ? ', ' : '';
                    this.creditCardNumbersString += `${payment.cardType} *${payment.cardNumber}`;
                }
            });
        }
    }

    payFee(fee) {
        if(!this.disabledSubmit) {
            const data = {elements: this.getPaymentsFormatted(fee)};
            this.disabledSubmit = true;
            const url = `/v1/payments_action.json`;
            this.amenitiesService.api.post('domainAmenities', url, data).subscribe(
                () => {
                    toastr.success('The Payment was paid successfully');
                    fee.status = true;
                    this.data.payments.find(p => fee.id == p.fee).status = true;
                    this.disabledSubmit = false;
                    this.amenitiesService.getData();
                    if(this.amenitiesService.view == 'calendar') {
                        if (this.authService.userIsResident)
                            this.amenitiesService.getAmenitiesForCalendarResident();
                        else
                            this.amenitiesService.getAmenitiesForCalendar();
                    }
                },
                error => {
                    this.api.errorHandler(error, 'Update failed!');
                    this.disabledSubmit = false;
                }
            );
        }
    }

    getPaymentsFormatted(fee): Array<any> {
        let total = '';
        if(fee.pmtAtTime)
            total = (this.getStartEndDayDifference() * parseFloat(fee.amount)).toString();
        else if(fee.pmtHourly)
            total = (this.getStartEndHourDifference() * parseFloat(fee.amount)).toString();
        else
            total = fee.amount;
        const pushable = {
            action: 'pay',
            payment: fee.paymentId,
            amount: total
        };
        return [pushable];
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-payments/amenities-payments.component.ts